module.exports = __webpack_public_path__ + "static/media/view.0f21c116.svg";